/**
 * Cookie 管理工具
 */

export default {
  /**
   * 设置cookie
   * @param {string} name - cookie名称
   * @param {string} value - cookie值
   * @param {number} days - 过期天数，默认为7天
   * @param {string} path - cookie路径，默认为'/'
   */
  setCookie(name, value, days = 7, path = '/') {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=${path}`;
  },

  /**
   * 获取cookie值
   * @param {string} name - cookie名称
   * @returns {string|null} - cookie值，不存在返回null
   */
  getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  },

  /**
   * 删除cookie
   * @param {string} name - cookie名称
   */
  deleteCookie(name) {
    this.setCookie(name, '', -1);
  },

  /**
   * 获取所有cookie
   * @returns {object} - 所有cookie的键值对对象
   */
  getAllCookies() {
    const cookies = {};
    document.cookie.split(';').forEach(cookie => {
      const [name, value] = cookie.trim().split('=');
      if (name) {
        cookies[name] = value || '';
      }
    });
    return cookies;
  },

  /**
   * 清除所有cookie
   */
  clearAllCookies() {
    Object.keys(this.getAllCookies()).forEach(name => {
      this.deleteCookie(name);
    });
  }
};
